import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('auditReport', [booksMenu])
  .controller('auditReportController', auditReportController)
  .name;


/* @ngInject */ function auditReportController($scope, BooksSvc, BusyScreen, SERVER, Alert, Session) {
  /*---------------------*/
  /* Sets default values */
  /*---------------------*/
  $scope.req = { reportFormat: 'PDF', percent: '100' };
  $scope.data = {};
  $scope.reportPage = Session.getSessionURL('/AuditReport.aspx');

  /*------------------------------------------------*/
  /* Empty object to be used with the csm validator */
  /* and is called in the validateInput function.   */
  /*------------------------------------------------*/
  $scope.valOption = {};
  $scope.validateInput = function () {
    /*------------------------------------------------------------*/
    /* checks to make sure the percent value is between 1 and 100 */
    /*------------------------------------------------------------*/
    if ($scope.req.percent < 1 || $scope.req.percent > 100) {
      Alert.error('Value must be between 1 and 100', 'Percent');
      return false;
    }
    return $scope.valOption.validate();
  };

  /*-----------------------------*/
  /* Static array of entry types */
  /*-----------------------------*/
  $scope.entryType = [
    { label: 'Checks', type: SERVER.BooksDBConstants.LET_CHECK },
    {
      label: 'Void Checks',
      type:
        SERVER.BooksDBConstants.LT_VOID +
        '_' +
        SERVER.BooksDBConstants.LET_CHECK
    },
    { label: 'Deposits', type: SERVER.BooksDBConstants.LET_DEPOSIT },
    {
      label: 'Journal Entries',
      type: SERVER.BooksDBConstants.LT_ADJUSTMENT
    },
    { label: 'Receipts', type: SERVER.BooksDBConstants.LET_RECEIPT },
    {
      label: 'Void Receipts',
      type:
        SERVER.BooksDBConstants.LT_VOID +
        '_' +
        SERVER.BooksDBConstants.LET_RECEIPT
    }
  ];

  /*------------------------------------------------*/
  /* Watches data.types and converts the array to a */
  /* string separated by a pipe (|) for submission. */
  /*------------------------------------------------*/
  $scope.$watch('data.types', function (types) {
    $scope.req.types = types ? types.join('|') : 0;
  });

  /*****************************************************************************
   * formatSites */
  /**
   * Returns the corresponding child sites from getChildSites() to display
   * in the sites typeahead.
   * When no match is found will retun "Select a site".
   *
   * @param  model  Current model value
   * @return        Corresponding site.
   *****************************************************************************/
  $scope.formatSites = function (model) {
    if ($scope.childSites) {
      for (var i = 0; i < $scope.childSites.length; i++) {
        if ($scope.childSites[i].id == model) {
          return $scope.childSites[i].name;
        }
      }
    }
    return 'Select a site';
  };

  /*-------------------*/
  /* Load initial data */
  /*-------------------*/
  BooksSvc.getOrganization().then(function (resp) {
    $scope.org = resp.data;

    BooksSvc.getChildSites().then(function (resp) {
      $scope.childSites = resp.data;
    });
    BusyScreen.setBusy(false);
  });
}